import { html } from "lit";
var icon_search_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="M21.034 19.776l6.706 6.707a.889.889 0 01-1.174 1.331l-.083-.074-6.707-6.706c.454-.384.874-.804 1.258-1.258zM12.89 4c4.91 0 8.889 3.98 8.889 8.889A8.89 8.89 0 1112.889 4zm0 1.778A7.111 7.111 0 1012.892 20a7.111 7.111 0 00-.003-14.222z"
      fill-rule="evenodd" />
  </svg>
`;
export {
  icon_search_default as default
};
//# sourceMappingURL=icon-search.js.map
